import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const bannerAdCampaignService = {
    createMessage: (companyId, campaignId, payload) => {
        return axiosMultipartFormDataInstance.post(
            `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.BANNER}/${API_PATH.MESSAGES}`,
            payload
        );
    },

    updateMessage: (companyId, campaignId, messageId, payload) => {
        return axiosMultipartFormDataInstance.post(
            `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.BANNER}/${API_PATH.MESSAGES}/${messageId}`,
            payload
        );
    },

    deleteMessage: (companyId, campaignId, messageId) => {
        return axiosInstance.delete(
            `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.BANNER}/${API_PATH.MESSAGES}/${messageId}`
        );
    },

    getMessage: (companyId, campaignId, messageId) => {
        return axiosInstance.get(
            `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.BANNER}/${API_PATH.MESSAGES}/${messageId}`
        );
    },

    getCampaignEchos: (companyId, campaignId) => {
        return axiosInstance.get(
            `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.BANNER}/${API_PATH.ECHOS}`
        );
    },
};

export default bannerAdCampaignService;
